import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export interface HawkThreatInfo {
  threat_level?: string
  threat_type?: string
  threat_name?: string
  md5?: string
  description?: string
}

@Injectable()
export class HawkEyeQueryService {
  constructor (private http: Http) {}

  async queryByHash (md5: string): Promise<HawkThreatInfo | null> {
    if (!md5) return null
    try {
      const res = await this.http.post<HawkThreatInfo>('/threat-intel/hawk_eye/query', {
        source_type: 'hawk_eye',
        hash: md5,
      })
      return res ?? null
    } catch {
      return null
    }
  }
}
